// import React, { useRef, useState } from "react";
// import {
//   Drawer,
//   Form,
//   Button,
//   Input,
//   message,
//   Select,
//   Checkbox,
//   notification,
// } from "antd";
// import { Table, Row, Col } from "react-bootstrap";
// import axios from "axios";
// import { API, Headers } from "../../Config";
// import moment from "moment";
// import PdfRefNumModal from "./PdfRefNumModal";
// import { POST } from "../../Config/ApiRequests";

// const { Option } = Select;
// function FormModal(props) {
//   const formRef = useRef();

//   const [loading, setLoading] = useState(false);
//   const [loading2, setLoading2] = useState(false);
//   const [userloading, setUserloading] = useState(false);
//   const [count, setCount] = useState(0);
//   const [download, setDownload] = useState(false);

//   const [data, setData] = useState([]);
//   const [value, setValue] = useState([]);
//   const [list, setList] = useState([]);
//   const [from, setFrom] = useState();
//   const [to, setTo] = useState();
//   const [userId, setUserId] = useState(0);

//   const onFinish = (val) => {
//     let uuid = `${value.userid}${moment().unix()}`;
//     let UUID = uuid.slice(0, 4);
//     setLoading(true);
//     if (list && list.length) {
//       let numberss = [];
//       // list.map((item) => {
//       //   // numberss = numberss + item.referance;
//       //   numberss.push(item.referance.toString());
//       // });
//       // let series_no = numberss.slice(numberss.indexOf(",") + 1).trim();
//       let requestObj = {
//         referance: numberss,
//         user_id: Number(value.userid),
//         series_no: Number(UUID),
//         from_no: from,
//         to_no: to,
//       };

//       axios({
//         method: "post",
//         url: API.BASR_URL + API.REFERENCE_NUM_LIST,
//         headers: Headers(),
//         data: requestObj,
//       })
//         .then(function (response) {
//           if ((response.status === 200, 201)) {
//             message.success("Success");
//             props.reload();
//             setLoading(false);
//           }
//         })
//         .catch(function (error) {
//           message.error("Something went wrong");
//           console.log(error);
//           notification.open({
//             message: "ERROR",
//             description: `${error.response.data.message}`,
//           });
//           setLoading(false);
//         });
//     }
//   };

//   const onValuesChange = (_, val) => {
//     console.log("onValuesChange====>", val);
//     setValue(val);
//   };

//   const selectUser = (val) => {
//     console.log(val);
//     setUserloading(true);
//     axios
//       .get(API.BASR_URL + API.REFERENCE_NUM_LIST + `/get_user/${val}`, {
//         headers: Headers(),
//       })
//       .then(function (response) {
//         if (response.status === 200) {
//           let data = response.data;
//           setData(data);
//           console.log(data);
//           let length = Number(data.length) - 1;
//           // let index = data.lastIndex();
//           if (data && data.length) {
//             formRef.current?.setFieldsValue({
//               from: data[length].to_no && data[length].to_no,
//             });
//           }
//           setUserloading(false);
//         }
//       })
//       .catch(function (error) {
//         console.log(error);
//         setUserloading(false);
//       });
//   };

//   const createSeries = async () => {
//     try {
//       setLoading2(true);
//       let api = "referance/create";
//       let obj = {
//         series_no: 1,
//         user_id: Number(userId),
//         from_no: 1,
//         to_no: 2,
//         numbers: list,
//         referance: list,
//       };

//       const create = await POST(api, obj);
//       if (create?.status) {
//         setLoading2(false);
//         message.success("Created Successfully");
//         props.reload();
//         props.onClose();
//       } else {
//         setLoading2(false);
//         message.success("Failed to create");
//       }
//     } catch (err) {
//       setLoading2(false);
//       console.log(err);
//     }
//   };

//   const generate = async (val) => {
//     try {
//       let arr = [];
//       // let _num = await generateDateTimeBasedNumber();
//       let _num = moment().unix();
//       let num = `${userId}${_num}`;
//       for (let i = 0; i < count; i++) {
//         let _id = Number(num) + Number(i);
//         arr.push(_id);
//       }
//       setList(arr);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   async function generateDateTimeBasedNumber() {
//     const now = new Date();
//     // Extract time components
//     const hours = now.getHours();
//     const minutes = now.getMinutes();
//     const seconds = now.getSeconds();
//     const milliseconds = now.getMilliseconds();
//     // Combine and hash into an 8-digit number
//     const hash =
//       (hours * 3600000 + minutes * 60000 + seconds * 1000 + milliseconds) %
//       100000000;
//     // Ensure it's exactly 8 digits
//     const uniqueNumber = hash.toString().padStart(8, "0");
//     return uniqueNumber;
//   }

//   const Clear = () => {
//     formRef.current.setFieldsValue({
//       from: "",
//       to: "",
//       count: "",
//     });
//     setList([]);
//   };

//   const printSave = () => {
//     // setDownload(true);
//     setTimeout(() => onFinish(), 1000);
//   };

//   return (
//     <div>
//       <Drawer
//         placement="right"
//         title={<span className="txt4">Generate Reference Number</span>}
//         width={720}
//         visible={props.visible}
//         onClose={props.onClose}
//         bodyStyle={{ paddingBottom: 80 }}
//       >
//         <Row>
//           <Col md="9">
//             <div>Select User</div>
//             <Select
//               size="large"
//               showSearch
//               style={{ width: "100%" }}
//               onChange={(val) => {
//                 setUserId(val);
//                 // selectUser(val);
//               }}
//             >
//               {props.users &&
//                 props.users.map((options) => (
//                   <Option key={options?.id}>
//                     {options?.id} - {options?.name} - {options?.email}
//                   </Option>
//                 ))}
//             </Select>
//           </Col>

//           <Col md="3">
//             <div>Count</div>
//             <Input
//               type="number"
//               onChange={(e) => setCount(Number(e.target.value))}
//               size="large"
//             />
//           </Col>
//         </Row>

//         <br />

//         <Row>
//           <Col md="7"></Col>

//           <Col md="5">
//             <Button
//               type="primary"
//               onClick={() => generate()}
//               style={{ width: "100%" }}
//               size="large"
//             >
//               Generate
//             </Button>
//           </Col>
//         </Row>
//         <br />
//         <hr />
//         <br />

//         {list?.length ? (
//           <div>
//             <Table striped bordered hover>
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Reference Number</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {list.map((item, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{item}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>
//         ) : null}

//         {/* <Form ref={formRef} onFinish={onFinish} onValuesChange={onValuesChange}>
//           <div>
//             <Form.Item name="userid" label="Select User">
//               <Select onChange={(val) => selectUser(val)}>
//                 {props.users &&
//                   props.users.map((options) => (
//                     <Option key={options.id}> {options.name}</Option>
//                   ))}
//               </Select>
//             </Form.Item>
//           </div>
//           <Table bordered>
//             <thead style={{ backgroundColor: "#1e88e5", color: "#fff" }}>
//               <tr>
//                 <th></th>
//                 <th>From</th>
//                 <th>To</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td></td>
//                 <td>
//                   <Form.Item
//                     name={"from"}
//                     style={{ padding: 0, margin: 0 }}
//                     rules={[{ required: true, message: "required" }]}
//                     hasFeedback={userloading}
//                     validateStatus="validating"
//                   >
//                     <Input disabled={data && data.length} />
//                   </Form.Item>
//                 </td>
//                 <td>
//                   <Form.Item name={"to"} style={{ padding: 0, margin: 0 }}>
//                     <Input disabled={!count} />
//                   </Form.Item>
//                 </td>
//               </tr>
//               <tr>
//                 <td></td>
//                 <td>
//                   Enter Total Count{" "}
//                   <Checkbox onChange={() => setCount(!count)}></Checkbox>
//                 </td>
//                 <td>
//                   <Form.Item name={"count"} style={{ padding: 0, margin: 0 }}>
//                     <Input disabled={count} />
//                   </Form.Item>
//                 </td>
//               </tr>
//               <tr>
//                 <td></td>
//                 <td></td>
//                 <td>
//                   <div style={{ display: "flex" }}>
//                     <Button onClick={() => Clear()}>Clear</Button>
//                     <div style={{ margin: 5 }}></div>
//                     <Button type="primary" onClick={(val) => generate(val)}>
//                       Generate
//                     </Button>
//                   </div>
//                 </td>
//               </tr>
//               {list && list.length ? (
//                 <>
//                   <tr>
//                     <td colSpan={3}>Numbers</td>
//                   </tr>
//                   {list.map((item, index) => {
//                     return (
//                       <tr key={index}>
//                         <td>{index + 1}</td>
//                         <td colSpan={2}>{item}</td>
//                       </tr>
//                     );
//                   })}
//                 </>
//               ) : null}
//               {list && list.length ? (
//                 <tr>
//                   <td colSpan={2}></td>
//                   <td>
//                     <div style={{ display: "flex" }}>
//                       <Button size="large" block onClick={() => printSave()}>
//                         Print & Save
//                       </Button>
//                       <div style={{ margin: 3 }} />
//                       <Button
//                         size="large"
//                         type="primary"
//                         block
//                         htmlType="submit"
//                         loading={loading}
//                       >
//                         Save all
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </Table>
//         </Form> */}

//         {list && list.length ? (
//           <tr>
//             <td colSpan={2}></td>
//             <td>
//               <div style={{ display: "flex" }}>
//                 <Button
//                   size="large"
//                   style={{ width: "200px" }}
//                   block
//                   onClick={() => createSeries()}
//                 >
//                   Save
//                 </Button>
//                 <div style={{ margin: 3 }} />
//                 {/* <Button
//                   size="large"
//                   type="primary"
//                   block
//                   htmlType="submit"
//                   loading={loading}
//                 >
//                   Save all
//                 </Button> */}
//               </div>
//             </td>
//           </tr>
//         ) : null}
//       </Drawer>
//       {download && list.length ? (
//         <PdfRefNumModal
//           selected={list}
//           visible={download}
//           onCancel={() => setDownload(false)}
//         />
//       ) : null}
//     </div>
//   );
// }

// export default FormModal;

// import React, { useRef, useState } from "react";
// import {
//   Drawer,
//   Form,
//   Button,
//   Input,
//   message,
//   Select,
//   Checkbox,
//   notification,
// } from "antd";
// import { Table, Row, Col } from "react-bootstrap";
// import axios from "axios";
// import { API, Headers } from "../../Config";
// import moment from "moment";
// import PdfRefNumModal from "./PdfRefNumModal";
// import { POST } from "../../Config/ApiRequests";
// import { useSelector } from "react-redux";

// const { Option } = Select;
// function FormModal(props) {
//   const formRef = useRef();
//   const Auth = useSelector((state) => state.Auth.user);
//   console.log("hello auth=========>>>>>>>>>>>>>",Auth)
//   console.log("hello props=========>>>>>>>>>>>>>",props)

//   // Place code mapping for branch names
//   const placeCodeMap = {
//     jeddah: "JD",
//     aldera: "AD",
//     makkah: "MK",
//     "yanbu al bahar": "YB",
//     tuwal: "TL",
//     cochin: "CN",
//     "al nakheel": "Al",
//     "khamis mushait": "KS",
//     bangladesh: "BD",
//     chennai: "CI",
//     brunei: "BR",
//     nepal: "NP",
//     riyadh: "RD",
//     delhi: "DL",
//     taif: "TF",
//     "mundra kutch district gujarat": "MN",
//     abha: "AB",
//     muhayil: "MH",
//   };

//   // Function to generate reference number with pattern: serial number + userid + branch name
//   const generateReferenceNumber = (userId, index) => {
//     try {
//       // Find the selected user from props.users to get their branch place
//       const selectedUser = props.users?.find((user) => user.id === userId);
//       const place = selectedUser?.branch?.place?.toLowerCase();
//       const placeCode = (placeCodeMap[place] || "XX").padStart(2, "X"); // 2 character place code
//       const userIdStr = (userId || "000").toString().padStart(3, "0"); // 3 character user id

//       // Generate 5 digit serial number using timestamp + index
//       const timestamp = Date.now();
//       const serialNumber = ((timestamp + index) % 100000)
//         .toString()
//         .padStart(5, "0"); // 5 digit serial

//       const referenceNumber = `${placeCode}${serialNumber}${userIdStr}`;

//       return referenceNumber;
//     } catch (error) {
//       console.error("Error generating reference number:", error);
//       // Fallback to original format if there's an error
//       return `${userId}${moment().unix()}${index}`;
//     }
//   };

//   const [loading, setLoading] = useState(false);
//   const [loading2, setLoading2] = useState(false);
//   const [userloading, setUserloading] = useState(false);
//   const [count, setCount] = useState(0);
//   const [download, setDownload] = useState(false);

//   const [data, setData] = useState([]);
//   const [value, setValue] = useState([]);
//   const [list, setList] = useState([]);
//   const [from, setFrom] = useState();
//   const [to, setTo] = useState();
//   const [userId, setUserId] = useState(0);

//   const onFinish = (val) => {
//     let uuid = `${value.userid}${moment().unix()}`;
//     let UUID = uuid.slice(0, 4);
//     setLoading(true);
//     if (list && list.length) {
//       let numberss = [];
//       // list.map((item) => {
//       //   // numberss = numberss + item.referance;
//       //   numberss.push(item.referance.toString());
//       // });
//       // let series_no = numberss.slice(numberss.indexOf(",") + 1).trim();
//       let requestObj = {
//         referance: numberss,
//         user_id: Number(value.userid),
//         series_no: Number(UUID),
//         from_no: from,
//         to_no: to,
//       };

//       axios({
//         method: "post",
//         url: API.BASR_URL + API.REFERENCE_NUM_LIST,
//         headers: Headers(),
//         data: requestObj,
//       })
//         .then(function (response) {
//           if ((response.status === 200, 201)) {
//             message.success("Success");
//             props.reload();
//             setLoading(false);
//           }
//         })
//         .catch(function (error) {
//           message.error("Something went wrong");
//           console.log(error);
//           notification.open({
//             message: "ERROR",
//             description: `${error.response.data.message}`,
//           });
//           setLoading(false);
//         });
//     }
//   };

//   const onValuesChange = (_, val) => {
//     console.log("onValuesChange====>", val);
//     setValue(val);
//   };

//   const selectUser = (val) => {
//     console.log(val);
//     setUserloading(true);
//     axios
//       .get(API.BASR_URL + API.REFERENCE_NUM_LIST + `/get_user/${val}`, {
//         headers: Headers(),
//       })
//       .then(function (response) {
//         if (response.status === 200) {
//           let data = response.data;
//           setData(data);
//           console.log(data);
//           let length = Number(data.length) - 1;
//           // let index = data.lastIndex();
//           if (data && data.length) {
//             formRef.current?.setFieldsValue({
//               from: data[length].to_no && data[length].to_no,
//             });
//           }
//           setUserloading(false);
//         }
//       })
//       .catch(function (error) {
//         console.log(error);
//         setUserloading(false);
//       });
//   };

//   const createSeries = async () => {
//     try {
//       console.log("list", list);
//       setLoading2(true);
//       let api = "referance/create";
//       let obj = {
//         series_no: 1,
//         user_id: Number(userId),
//         from_no: 1,
//         to_no: 2,
//         numbers: list,
//         referance: list,
//       };

//       const create = await POST(api, obj);
//       if (create?.status) {
//         setLoading2(false);
//         message.success("Created Successfully");
//         props.reload();
//         props.onClose();
//       } else {
//         setLoading2(false);
//         message.success("Failed to create");
//       }
//     } catch (err) {
//       setLoading2(false);
//       console.log(err);
//     }
//   };

//   const generate = async (val) => {
//     try {
//       let arr = [];
//       for (let i = 0; i < count; i++) {
//         let referenceNumber = generateReferenceNumber(userId, i);
//         arr.push(referenceNumber);
//       }
//       setList(arr);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const Clear = () => {
//     formRef.current.setFieldsValue({
//       from: "",
//       to: "",
//       count: "",
//     });
//     setList([]);
//   };

//   const printSave = () => {
//     // setDownload(true);
//     setTimeout(() => onFinish(), 1000);
//   };

//   return (
//     <div>
//       <Drawer
//         placement="right"
//         title={<span className="txt4">Generate Reference Number</span>}
//         width={720}
//         visible={props.visible}
//         onClose={props.onClose}
//         bodyStyle={{ paddingBottom: 80 }}
//       >
//         <Row>
//           <Col md="9">
//             <div>Select User</div>
//             <Select
//               size="large"
//               showSearch
//               style={{ width: "100%" }}
//               onChange={(val) => {
//                 setUserId(val);
//                 // selectUser(val);
//               }}
//             >
//               {props.users &&
//                 props.users.map((options) => (
//                   <Option key={options?.id}>
//                     {options?.id} - {options?.name} - {options?.email}
//                   </Option>
//                 ))}
//             </Select>
//           </Col>

//           <Col md="3">
//             <div>Count</div>
//             <Input
//               type="number"
//               onChange={(e) => setCount(Number(e.target.value))}
//               size="large"
//             />
//           </Col>
//         </Row>

//         <br />

//         <Row>
//           <Col md="7"></Col>

//           <Col md="5">
//             <Button
//               type="primary"
//               onClick={() => generate()}
//               style={{ width: "100%" }}
//               size="large"
//             >
//               Generate
//             </Button>
//           </Col>
//         </Row>
//         <br />
//         <hr />
//         <br />

//         {list?.length ? (
//           <div>
//             <Table striped bordered hover>
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Reference Number</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {list.map((item, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{item}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>
//         ) : null}

//         {/* <Form ref={formRef} onFinish={onFinish} onValuesChange={onValuesChange}>
//           <div>
//             <Form.Item name="userid" label="Select User">
//               <Select onChange={(val) => selectUser(val)}>
//                 {props.users &&
//                   props.users.map((options) => (
//                     <Option key={options.id}> {options.name}</Option>
//                   ))}
//               </Select>
//             </Form.Item>
//           </div>
//           <Table bordered>
//             <thead style={{ backgroundColor: "#1e88e5", color: "#fff" }}>
//               <tr>
//                 <th></th>
//                 <th>From</th>
//                 <th>To</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td></td>
//                 <td>
//                   <Form.Item
//                     name={"from"}
//                     style={{ padding: 0, margin: 0 }}
//                     rules={[{ required: true, message: "required" }]}
//                     hasFeedback={userloading}
//                     validateStatus="validating"
//                   >
//                     <Input disabled={data && data.length} />
//                   </Form.Item>
//                 </td>
//                 <td>
//                   <Form.Item name={"to"} style={{ padding: 0, margin: 0 }}>
//                     <Input disabled={!count} />
//                   </Form.Item>
//                 </td>
//               </tr>
//               <tr>
//                 <td></td>
//                 <td>
//                   Enter Total Count{" "}
//                   <Checkbox onChange={() => setCount(!count)}></Checkbox>
//                 </td>
//                 <td>
//                   <Form.Item name={"count"} style={{ padding: 0, margin: 0 }}>
//                     <Input disabled={count} />
//                   </Form.Item>
//                 </td>
//               </tr>
//               <tr>
//                 <td></td>
//                 <td></td>
//                 <td>
//                   <div style={{ display: "flex" }}>
//                     <Button onClick={() => Clear()}>Clear</Button>
//                     <div style={{ margin: 5 }}></div>
//                     <Button type="primary" onClick={(val) => generate(val)}>
//                       Generate
//                     </Button>
//                   </div>
//                 </td>
//               </tr>
//               {list && list.length ? (
//                 <>
//                   <tr>
//                     <td colSpan={3}>Numbers</td>
//                   </tr>
//                   {list.map((item, index) => {
//                     return (
//                       <tr key={index}>
//                         <td>{index + 1}</td>
//                         <td colSpan={2}>{item}</td>
//                       </tr>
//                     );
//                   })}
//                 </>
//               ) : null}
//               {list && list.length ? (
//                 <tr>
//                   <td colSpan={2}></td>
//                   <td>
//                     <div style={{ display: "flex" }}>
//                       <Button size="large" block onClick={() => printSave()}>
//                         Print & Save
//                       </Button>
//                       <div style={{ margin: 3 }} />
//                       <Button
//                         size="large"
//                         type="primary"
//                         block
//                         htmlType="submit"
//                         loading={loading}
//                       >
//                         Save all
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </Table>
//         </Form> */}

//         {list && list.length ? (
//           <tr>
//             <td colSpan={2}></td>
//             <td>
//               <div style={{ display: "flex" }}>
//                 <Button
//                   size="large"
//                   style={{ width: "200px" }}
//                   block
//                   onClick={() => createSeries()}
//                 >
//                   Save
//                 </Button>
//                 <div style={{ margin: 3 }} />
//                 {/* <Button
//                   size="large"
//                   type="primary"
//                   block
//                   htmlType="submit"
//                   loading={loading}
//                 >
//                   Save all
//                 </Button> */}
//               </div>
//             </td>
//           </tr>
//         ) : null}
//       </Drawer>
//       {download && list.length ? (
//         <PdfRefNumModal
//           selected={list}
//           visible={download}
//           onCancel={() => setDownload(false)}
//         />
//       ) : null}
//     </div>
//   );
// }

// export default FormModal;


// ================davood code =============================================


import React, { useRef, useState } from "react";
import {
  Drawer,
  Form,
  Button,
  Input,
  message,
  Select,
  Checkbox,
  notification,
} from "antd";
import { Table, Row, Col } from "react-bootstrap";
import axios from "axios";
import { API, Headers } from "../../Config";
import moment from "moment";
import PdfRefNumModal from "./PdfRefNumModal";
import { POST } from "../../Config/ApiRequests";
import { useSelector } from "react-redux";

const { Option } = Select;
function FormModal(props) {
  const formRef = useRef();
  const Auth = useSelector((state) => state.Auth.user);

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [userloading, setUserloading] = useState(false);
  const [count, setCount] = useState(0);
  const [download, setDownload] = useState(false);

  const [data, setData] = useState([]);
  const [value, setValue] = useState([]);
  const [list, setList] = useState([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [userId, setUserId] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);

  // Function to clear generation session
  const clearGenerationSession = async () => {
    try {
      await axios({
        method: "post",
        url: API.BASR_URL + "referance/clear-generation-session",
        headers: {
          'Content-Type': 'application/json',
          ...Headers()
        },
        data: {
          user_id: Number(userId),
          branch_code: selectedUser?.branch?.branch_code || "XX"
        }
      });
      console.log("Generation session cleared");
    } catch (error) {
      console.log("Error clearing session:", error);
    }
  };

  // Function to generate reference numbers (NOT saved to database)
  const generateReferenceNumbers = async () => {
    if (!userId || !selectedUser || count <= 0) {
      message.error("Please select a user and enter count");
      return;
    }

    try {
      setLoading(true);
      const generatedNumbers = [];

      // Clear any existing session first
      await clearGenerationSession();

      console.log(`Starting to generate ${count} reference numbers for user ${userId}, branch ${selectedUser.branch?.branch_code}`);

      // Generate multiple reference numbers by calling the API multiple times
      for (let i = 0; i < count; i++) {
        try {
          console.log(`Making API call ${i + 1}/${count}...`);
          console.log(`Request data:`, {
            user_id: Number(userId),
            branch_code: selectedUser.branch?.branch_code || "XX"
          });

          const response = await axios({
            method: "post",
            url: API.BASR_URL + "referance/generate-reference",
            headers: {
              'Content-Type': 'application/json',
              ...Headers()
            },
            data: {
              user_id: Number(userId),
              branch_code: selectedUser.branch?.branch_code || "XX"
            }
          });
          if (response.data.success) {
            generatedNumbers.push(response.data.reference_number);

            if (i < count - 1) {
              await new Promise(resolve => setTimeout(resolve, 50));
            }
          } else {

            message.error(`Failed to generate reference number ${i + 1}: ${response.data.message || 'Unknown error'}`);
            break;
          }
        } catch (error) {
          console.error(error);


          if (error.response?.status === 400) {
            message.error(`Validation error: ${error.response.data.message || 'Bad request'}`);
            break;
          } else if (error.response?.status === 401) {
            message.error(`Authentication error: Please check your login status`);
            break;
          } else if (error.response?.status === 500) {
            message.error(`Server error: ${error.response.data.message || 'Internal server error'}`);
            break;
          } else {
            message.error(`Failed to generate reference number ${i + 1}: ${error.message || 'Unknown error'}`);
            break;
          }
        }
      }

      if (generatedNumbers.length > 0) {
        setList(generatedNumbers);
        message.success(`Generated ${generatedNumbers.length} unique reference numbers successfully (not saved yet)`);
        console.log(`Final generated numbers:`, generatedNumbers);
      }
    } catch (error) {
      message.error("Failed to generate reference numbers");
    } finally {
      setLoading(false);
    }
  };

  // Updated save function to save generated numbers to database
  const createSeries = async () => {
    try {

      setLoading2(true);

      // Save the generated reference numbers to database
      let obj = {
        user_id: Number(userId),
        reference_numbers: list,
        series_no: 1,
        from_no: 1,
        to_no: list.length,
        branch_code: selectedUser?.branch?.branch_code || "XX"
      };



      const response = await axios({
        method: "post",
        url: API.BASR_URL + "referance/save-generated-references",
        headers: {
          'Content-Type': 'application/json',
          ...Headers()
        },
        data: obj
      });

      if (response.data.success) {
        setLoading2(false);
        message.success(`Successfully saved ${response.data.saved_count} reference numbers to database`);

        // Reload the table data with a small delay to ensure data is saved
        setTimeout(() => {
          props.reload();
        }, 1000);

        // Close the modal
        props.onClose();

        // Clear the form
        setList([]);
        setCount(0);
        setUserId(0);
        setSelectedUser(null);
      } else {
        setLoading2(false);

        message.error("Failed to save reference numbers");
      }
    } catch (err) {
      setLoading2(false);

      message.error("Failed to save reference numbers to database");
    }
  };

  const Clear = async () => {
    // Clear generation session when clearing the form
    if (userId && selectedUser) {
      await clearGenerationSession();
    }

    formRef.current?.setFieldsValue({
      from: "",
      to: "",
      count: "",
    });
    setList([]);
    setCount(0);
    setUserId(0);
    setSelectedUser(null);
  };

  // Handle user selection
  const handleUserChange = (val) => {
    const user = props.users?.find(u => u.id === val);
    setUserId(val);
    setSelectedUser(user);
  };

  return (
    <div>
      <Drawer
        placement="right"
        title={<span className="txt4">Generate Reference Number</span>}
        width={720}
        visible={props.visible}
        onClose={props.onClose}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Row>
          <Col md="9">
            <div>Select User</div>
            <Select
              size="large"
              showSearch
              style={{ width: "100%" }}
              onChange={handleUserChange}
              placeholder="Select a user"
            >
              {props.users &&
                props.users.map((options) => (
                  <Option key={options?.id}>
                    {options?.id} - {options?.name} - {options?.email} - {options?.branch?.branch_code || "N/A"}
                  </Option>
                ))}
            </Select>
          </Col>

          <Col md="3">
            <div>Count</div>
            <Input
              type="number"
              value={count}
              onChange={(e) => setCount(Number(e.target.value))}
              size="large"
              placeholder="Enter count"
              min={1}
            />
          </Col>
        </Row>

        <br />

        <Row>
          <Col md="7">
            {selectedUser && (
              <div style={{ padding: "8px", backgroundColor: "#f5f5f5", borderRadius: "4px" }}>
                <strong>Selected User:</strong> {selectedUser.name} |
                <strong> Branch:</strong> {selectedUser.branch?.branch_code || "N/A"}
              </div>
            )}
          </Col>

          <Col md="5">
            <Button
              type="primary"
              onClick={generateReferenceNumbers}
              style={{ width: "100%" }}
              size="large"
              loading={loading}
              disabled={!userId || !count || count <= 0}
            >
              {loading ? "Generating..." : "Generate (Preview)"}
            </Button>
          </Col>
        </Row>
        <br />
        <hr />
        <br />

        {list?.length ? (
          <div>
            <div style={{ marginBottom: "10px" }}>
              <strong>Generated Reference Numbers ({list.length}) - Not Saved Yet:</strong>
            </div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Reference Number</th>
                </tr>
              </thead>
              <tbody>
                {list.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : null}

        {list && list.length ? (
          <div style={{ marginTop: "20px" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              {/* <Button
                size="large"
                style={{ width: "200px" }}
                onClick={() => {
                  setDownload(true);
                  setTimeout(() => createSeries(), 1000);
                }}
                loading={loading2}
                type="primary"
              >
                Print & Save
              </Button> */}
              <Button
                size="large"
                onClick={createSeries}
                style={{ width: "200px" }}
                loading={loading2}
                type="default"
              >
                Save
              </Button>
            </div>
          </div>
        ) : null}
      </Drawer>
      {download && list.length ? (
        <PdfRefNumModal
          selected={list}
          visible={download}
          onCancel={() => setDownload(false)}
        />
      ) : null}
    </div>
  );
}

export default FormModal;





